import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GeneralService } from '../../../shared/services/general.service';
import { DeviceTypesMap, DeviceType, CONNECTIVITY_STATE, STATE_VAR, GROUP } from '../../devices/devices.constant';
import { Device } from '../../devices/devices.model_new';
import { Routine } from '../routines.model';
import { RoutinesService } from '../routines.service';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { MatSpinner, MatDialog, MatDialogRef } from '@angular/material';
import { HttpResponse } from 'aws-sdk';
import { RoutinesDialogComponent } from '../routines-dialog/routines-dialog.component';
import { SnackBarComponent } from '../../../layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material';


@Component({
  selector: 'app-routines-card',
  templateUrl: './routines-card.component.html',
  styleUrls: ['./routines-card.component.scss']
})
export class RoutinesCardComponent implements OnInit {
  @Output() action: EventEmitter<Routine> = new EventEmitter<Routine>();
  @Output() pageLoad: EventEmitter<Routine> = new EventEmitter<Routine>();


  @Input()
  routine: Routine;
  message: string;
  @Input()
  routineNumber: number;
  deviceNumber: number;
  loading: boolean = false;
  done: boolean = false;
  dialogRef: MatDialogRef<RoutinesDialogComponent>;


  constructor(
    private routinesService: RoutinesService, public dialog: MatDialog, public snackBar: MatSnackBar,
    ) { }

  ngOnInit() {
    this.routineNumber = this.routineNumber+1;
    this.deviceNumber = this.routine.config.length;
  }

  toggleLoading(value: boolean){
    this.loading = value;
  } 
  setDone(value: boolean){
    this.done = value;
  } 
  
  
 
  activate() {
    event.stopPropagation();
    this.toggleLoading(true);
    this.routinesService.activateRoutine(this.routine.houseId, this.routine.routineId).subscribe(res => {
      if(!res){
      this.toggleLoading(false);
      this.setDone(true);
      setTimeout(() => {this.setDone(false)},1000);
    } else {
      this.toggleLoading(false);
      this.message = "There was an error activating this routine. Try again later"
      this.openSnackBar();
    }});
  }

  openRoutine() {
    this.dialogRef = this.dialog.open(RoutinesDialogComponent, {
      data: {
        name: this.routine.name,
        type: "View",
        devices: this.routine.config,
        routine: this.routine
      },
      autoFocus: false,
      panelClass: 'inputPopup'
    });

    this.dialogRef.componentInstance.delete_action.subscribe(update => {
      if (update) {
        this.deviceNumber = this.routine.config.length;
        this.action.emit(update);
      }
    });

      this.dialogRef.componentInstance.save_action.subscribe(update => {
        if (update) {
          this.deviceNumber = this.routine.config.length;
          this.action.emit(update);
        }
      });

  }

  editRoutine() {
    event.stopPropagation();
      this.dialogRef = this.dialog.open(RoutinesDialogComponent, {
        data: {
          name: this.routine.name,
          type: "Edit",
          devices: this.routine.config,
          routine: this.routine
        },
        autoFocus: false,
        panelClass: 'inputPopup'
      });

      this.dialogRef.componentInstance.delete_action.subscribe(update => {
        if (update) {
          this.deviceNumber = this.routine.config.length;
          this.action.emit(update);
        }
      });

      this.dialogRef.componentInstance.save_action.subscribe(update => {
        if (update) {
          this.deviceNumber = this.routine.config.length;
          this.action.emit(update);
        }
      });

      
  }
  

  openSnackBar() {
    setTimeout(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        data: this.message,
        duration: 3000,
        verticalPosition: 'bottom',
        panelClass: 'snackbar-panel',
      });
    setTimeout(() => {
        this.snackBar.dismiss();
      }, 3500);
    }, 500);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/entities/routines/routines-card/routines-card.component.ts